import { render, staticRenderFns } from "./TraxTrainingCompetencyIndexEdit.vue?vue&type=template&id=270deb1b"
import script from "./TraxTrainingCompetencyIndexEdit.vue?vue&type=script&lang=js"
export * from "./TraxTrainingCompetencyIndexEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports